"use client";

import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden !bg-[url(https://evolving-garfish.10web.cloud/wp-content/uploads/2026/02/DealForge_Logo_Transparent_Tight.png)]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/austin_texas_skyline_downtown.png)] bg-cover bg-center animate-[zoom-in_20s_ease-out_forwards]" />

      {}
      <div className="absolute inset-0 bg-linear-to-b from-black/60 via-black/40 to-black/70" />

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center">
        {}
        <div ref={headingRef} className={`transition-all duration-[800ms] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="text-[64px] md:text-[80px] lg:text-[96px] font-bold uppercase tracking-widest text-white mb-6 leading-[1.1]">
            Where Deals Are Forged
          </h1>
          <p className="text-[18px] md:text-[22px] text-white/90 max-w-3xl mx-auto mb-12 leading-relaxed">
            Strategic real estate advisory and deal creation for developers,
            landowners, and investors seeking transformational opportunities.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`transition-all duration-[800ms] delay-300 ease-[var(--ease-smooth)] ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Button asChild className="bg-accent text-foreground-accent px-10 py-6 text-base uppercase tracking-wide font-semibold rounded-(length:--radius-md) hover:bg-accent-hover hover:scale-[1.02] active:bg-accent-active active:scale-[0.98] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] shadow-medium hover:shadow-strong">
            <Link to="#approach">Start a Conversation</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10">
        <Link to="#about" className="flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors duration-300">
          <span className="text-sm uppercase tracking-wider font-medium">
            Scroll
          </span>
          <ChevronDown className="size-6 animate-bounce" />
        </Link>
      </div>

      <style jsx>{`
        @keyframes zoom-in {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.15);
          }
        }
      `}</style>
    </section>;
}